var _dec, _dec2, _dec3, _dec4, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { classNames, classNameBindings, layout as templateLayout } from '@ember-decorators/component';
import { action, computed } from '@ember/object';
import Component from '@ember/component';
import { isNone } from '@ember/utils';
import layout from '../templates/components/fly-select';

/**
  The fly-select component has two required parameters: items, an enumerabl
  list of item objects, and selectedValue, a two-way binding for the selected
  item's value.

  ```hbs
  <FlySelect
    \@items={{options}}
    \@selectedValue={{selectedValue}} />
  ```

  @class FlySelect
  @public
 */
let FlySelect = (_dec = classNames('fly-select'), _dec2 = classNameBindings('hasError:is-error', 'hasError:fly-form-error', 'disabled:is-disabled', 'icon:fly-select--icon'), _dec3 = templateLayout(layout), _dec4 = computed('selectedValue'), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = class FlySelect extends Component {
  constructor(...args) {
    super(...args);
    /**
      The list of items to display in the `select` menu. It should be an array of
      object with a `value` and `label` key.
       ```json
      const options = [
        { value: 'dmr', label: 'Dennis Ritchie' },
        { value: 'gbmh', label: 'Grace Hopper' },
        { value: 'mhh', label: 'Margaret Hamilton' },
        { value: 'rob', label: 'Rob Pike' }
      ];
      ```
       @argument items
      @type array
     */
    _defineProperty(this, "items", null);
    /**
      The selected value for the `select` element. It corresponds to a `value` key
      in the `items` array.
       @argument selectedValue
      @type string
     */
    _defineProperty(this, "selectedValue", null);
    /**
      Because the currently selected value is based on the content of the DOM, all
      values are strings by default. This breaks bindings to non-string types.
       If you want to bind to other types, use the `typecast` attribute. Currently,
      the only supported `typecast` setting is `"boolean"`, but it should be easy
      to add `"number"` if needed.
       @argument typecast
      @type string
     */
    _defineProperty(this, "typecast", null);
    /**
      Whether the select element is currently disabled or not.
       @argument disabled
      @type boolean
     */
    _defineProperty(this, "disabled", null);
    /**
      Whether the field has an error associated to it. This is usually from
      validation, but could be from anything.
       @argument hasError
      @type boolean
     */
    _defineProperty(this, "hasError", null);
    /**
      The error message to display when an error has occured. The prescence of
      this attribute does not signal that an error has occured. For the error
      message to be visible, you must also set `hasError`.
       @argument errorMessage
      @type string
     */
    _defineProperty(this, "errorMessage", null);
    /**
      An optional extra component to show beneath the select element, error
      error message, etc.
       @argument extraComponent
      @type Ember.Component
     */
    _defineProperty(this, "extraComponent", null);
    /**
      The "id" attribute passed to the select element
       @argument selectId?
      @type string
     */
    _defineProperty(this, "selectId", null);
    /**
      The "name" attribute passed to the select element
       @argument name?
      @type string
     */
    _defineProperty(this, "name", null);
  }
  get selectedTypecastValue() {
    return this.selectedValue;
  }
  set selectedTypecastValue(value) {
    let {
      typecast
    } = this;
    if (typecast === 'boolean') {
      value = value === 'true';
    }
    this.set('selectedValue', value);
    return value;
  }
  _selectedValueExists() {
    let {
      selectedValue,
      items
    } = this.getProperties('selectedValue', 'items');
    if (isNone(items) || isNone(selectedValue)) {
      return false;
    }
    return items.some(item => item.value === selectedValue);
  }
  didRender() {
    super.didRender(...arguments);

    // Fixes a Firefox bug.
    // https://github.com/emberjs/ember.js/issues/15484
    // When this component rerenders with a new list of items (for example,
    // because some items change their disabled state), Firefox gets confused as
    // to which element should be selected.
    // On a rerender, Firefox will mark the first item as selected, because it
    // gets rendered slightly before rendering other options. Firefox wants an
    // option to be selected, so - while rendering - it doesn't see the
    // currently selectedValue, it just selects the first one.
    // The component still thinks selectedValue is selected, but the browser
    // will show a different item, leading to weird behaviour.
    // Manually setting the select node's value after a render/rerender makes
    // sure the select node is always in sync with the options' "selected"
    // attributes, fixing the problem.
    if (this._selectedValueExists()) {
      this.element.querySelector('select').value = this.selectedTypecastValue;
    }
  }
  onChangeAction(event) {
    this.set('selectedTypecastValue', event.target.value);
    let {
      onChange
    } = this;
    if (typeof onChange === 'function') {
      onChange(this.selectedTypecastValue);
    }
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "selectedTypecastValue", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "selectedTypecastValue"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeAction", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeAction"), _class2.prototype)), _class2)) || _class) || _class) || _class);
export { FlySelect as default };